/**
 * Service worker registration for PWA support.
 * Registers the service worker and sets up periodic update checks.
 */

export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        console.log('[Sentinel] Service worker registered, scope:', reg.scope);

        // Check for updates every 30 minutes
        setInterval(() => { reg.update(); }, 30 * 60 * 1000);
      })
      .catch((err) => {
        console.warn('[Sentinel] Service worker registration failed:', err);
      });
  });
}

/**
 * Desktop cleanup. Builds shipped before the isTauriRuntime() detection
 * fix took the web path and registered the service worker inside the
 * Tauri webview. sw.js answers navigations cache-first, so a leftover
 * registration can pin an upgraded install (or a desktop:dev session)
 * to the old cached app shell. Unregister everything and drop the
 * origin caches so the packaged app always boots fresh from disk.
 */
export async function unregisterServiceWorkers(): Promise<void> {
  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((reg) => reg.unregister()));
      if (registrations.length > 0) {
        console.log('[Sentinel] Unregistered', registrations.length, 'stale service worker(s)');
      }
    }
    if ('caches' in globalThis) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  } catch (err) {
    console.warn('[Sentinel] Service worker cleanup failed:', err);
  }
}
